import { sortByPtBR } from '../../../../helper/sortHelper';
import './DashboardFilters.scss';

const DashboardFilters = ({
  selectedDepartment,
  selectedPosition,
  onDepartmentChange,
  onPositionChange,
  units = []
}) => {
  const safeUnits = Array.isArray(units) ? units : [];
  const departmentOptions = sortByPtBR(safeUnits.map(u => u.name));
  const selectedUnit = safeUnits.find(u => u.name === selectedDepartment);
  const positionOptions = ['Todos', ...sortByPtBR(selectedUnit ? selectedUnit.roles : [])];

  return (
    <div className="dashboard-filters-card">
      <div className="dashboard-filters-row">
        <div className="dashboard-filters-select-group">
          <div>
            <label className="dashboard-filters-label">Área</label>
            <select
              className="dashboard-filters-select"
              value={selectedDepartment}
              onChange={e => onDepartmentChange(e.target.value)}
            >
              {departmentOptions?.map(dept => (
                <option key={dept} value={dept}>{dept}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="dashboard-filters-label">Cargo</label>
            <select
              className="dashboard-filters-select"
              value={selectedPosition}
              onChange={e => onPositionChange(e.target.value)}
            >
              {positionOptions?.map(position => (
                <option key={position} value={position}>{position}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardFilters;
